/**
 * Lazy Google Maps JS API loader. Degrades gracefully: if no key is configured
 * (VITE_GOOGLE_MAPS_API_KEY), hasMaps() is false and callers skip the map.
 */
const KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "";
export const MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || "DEMO_MAP_ID";

let loaderPromise = null;

export function hasMaps() {
  return Boolean(KEY);
}

export function loadGoogleMaps() {
  if (!KEY) return Promise.reject(new Error("Google Maps API key not configured"));
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&libraries=places&v=weekly`;
    script.async = true;
    script.onload = () => resolve(window.google.maps);
    script.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(script);
  });
  return loaderPromise;
}
